export default __webpack_public_path__ + "static/media/pcpe.bd0dd836.svg";